module.exports = __webpack_public_path__ + "static/media/photo-1516137235045-2937f026afed.edabee63.jfif";